export default __webpack_public_path__ + "static/media/UNICEF_Logo_Light.8dda4925.png";